module.exports = __webpack_public_path__ + "img/zc_sel.ea895e6b.svg";